import React from 'react';
import { PersonalCabinet } from './pages/PersonalCabinet';
export function App() {
  return <PersonalCabinet data-id="element-0" />;
}